import { useMutation } from '@tanstack/react-query';
import { Alert } from 'rsuite';

import * as service from '../services';
import { SavingFiltersData } from '../types';

export const useAderenciaPrecosSavingFilters = () => {
  const saveFilters = async (data: SavingFiltersData) => {
    const resp = await service.savingAderenciaFilters(data);
    return resp;
  };

  const successAction = () => {
    Alert.success('Filtro salvo com sucesso');
  };

  const mutate = useMutation({
    mutationFn: saveFilters,
    onSuccess: successAction,
  });

  return {
    handleAderenciaSaveFilters: mutate.mutateAsync,
  };
};
